import { Cloud, CloudOff, RefreshCw } from 'lucide-react';

import { useOfflineStatus } from '@/lib/use-offline-status';

import { OfflineQueuePanel } from './OfflineQueuePanel';

export function OfflineStatusBadge() {
  const { cloudStatus, isOnline, pendingCount, queuedCount, syncingCount, failedCount, conflictCount } =
    useOfflineStatus();
  const Icon = cloudStatus === 'offline' ? CloudOff : Cloud;
  const label =
    cloudStatus === 'online' ? 'Cloud online' : cloudStatus === 'degraded' ? 'Cloud degraded' : 'Offline';
  const shortLabel =
    cloudStatus === 'online' ? 'Online' : cloudStatus === 'degraded' ? 'Degraded' : 'Offline';
  const iconClass =
    cloudStatus === 'online'
      ? 'h-3.5 w-3.5 text-green-600'
      : cloudStatus === 'degraded'
        ? 'h-3.5 w-3.5 text-amber-600'
        : 'h-3.5 w-3.5 text-red-600';
  const queueSummary = [
    queuedCount ? `${queuedCount} queued` : null,
    syncingCount ? `${syncingCount} syncing` : null,
    failedCount ? `${failedCount} failed` : null,
    conflictCount ? `${conflictCount} review` : null,
  ].filter(Boolean);
  const title =
    pendingCount > 0
      ? `${label}. ${queueSummary.join(', ')}.`
      : label;

  return (
    <OfflineQueuePanel isOnline={isOnline}>
      <button
        type="button"
        className="flex h-8 items-center gap-1.5 rounded-md border border-border px-2 text-xs text-muted-foreground hover:bg-muted hover:text-foreground"
        title={title}
        aria-label={title}
      >
        <Icon className={iconClass} />
        <span className="sm:hidden">{shortLabel}</span>
        <span className="hidden sm:inline">{label}</span>
        {queuedCount + failedCount > 0 && (
          <span className="flex items-center gap-1 rounded bg-muted px-1.5 py-0.5 text-[11px] text-foreground">
            <RefreshCw className="h-3 w-3" />
            {queuedCount + failedCount}
          </span>
        )}
        {conflictCount > 0 && (
          <span className="rounded bg-amber-100 px-1.5 py-0.5 text-[11px] text-amber-800">
            {conflictCount}
          </span>
        )}
      </button>
    </OfflineQueuePanel>
  );
}
